import { v1 as uuidv1, v5 as uuidv5 } from 'uuid';

export class Guid {

    // static Empty = '00000000-0000-0000-0000-000000000000';

    static v5(value: string, ns: string): string {
        return uuidv5(value, ns);
    }

    static v1(): string {
        return uuidv1();
    }

    static randomWithNs(ns: string): string {
        return Guid.v5(Guid.v1(), ns);
    }
}
